import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../constant.js";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
Modal.setAppElement("#root");

const Cancleorder = ({ orderid }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [err, setError] = useState("");
  const [status, setStatus] = useState("");
  const [confurm, setconfurm] = useState("");

  const navigate = useNavigate();

  const canclealltrade = async () => {
    closeModal();
    navigate("/trades");
    window.location.reload();
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModal2 = () => {
    setIsOpen(false);
  };
  const customStyles = {
    content: {
      width: "200px",
      height: "10px",
      margin: "auto",
      border: "1px solid #ccc",
    },
  };

  const confarmation = (con) => {
    setStatus("");
    setconfurm(con);
    openModal();
  };
  const ordertype = async (type) => {
    // console.log('Type : '+type)
    closeModal();
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", token);
    formdata.append("orderID", type);
    formdata.append("type", 5);
    const result = await axios.post(
      baseUrl + `authController/closeCancelTrade`,
      formdata,
    );
    setResponse(result.data.message);
    setStatus(result.data.status);

    openModal();

    setconfurm("");
  };
  return (
    <>
      <div className="close_section" style={{ margin: "7px" }}>
        <button
          type="button"
          onClick={() => confarmation(3)}
          style={{
            border: "1px solid #ed0017",
            marginRight: "10px",
            padding: "2px 10px",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "10px",
            background: "#ed0017",
          }}
        >
          Cancel All pending MCX Orders
        </button>
        <button
          type="button"
          onClick={() => confarmation(4)}
          style={{
            border: "1px solid #ed0017",
            padding: "2px 10px",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "10px",
            background: "#ed0017",
          }}
        >
          Cancel All pending NSE Orders
        </button>
      </div>

      {confurm == 3 && (
        <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
          <div className="module-content">
            <h6>
              Are you sure you wnt to
              <br />
              close all pending MCX orders?
            </h6>
            <div style={{ display: "flex" }}>
              <button onClick={closeModal}>DECILNE</button>
              <button onClick={() => ordertype(1)}>CONFIRM</button>
            </div>
          </div>
        </Modal>
      )}
      {confurm == 4 && (
        <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
          <div className="module-content">
            <h6>
              Are you sure you wnt to
              <br />
              close all pending NSE orders?
            </h6>
            <div style={{ display: "flex" }}>
              <button onClick={closeModal}>DECILNE</button>
              <button onClick={() => ordertype(2)}>CONFIRM</button>
            </div>
          </div>
        </Modal>
      )}
      {status === 1 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            src="assets/img/icons/checked.png"
            className="img-fluid color_icons"
          />
          <h2>Order Detail</h2>
          <p>{response}</p>
          <button onClick={canclealltrade}>Ok</button>
        </Modal>
      )}
      {status === 0 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            src="assets/img/icons/failed.png"
            className="img-fluid color_icons"
          />
          <h2>Order Detail</h2>
          <p>{response}</p>
          <button onClick={closeModal}>Ok</button>
        </Modal>
      )}
    </>
  );
};

export default Cancleorder;
